const Routes = {
  home: "/",
  logout: "/logout",
  app: "/app/:app",
};

export default Routes;
